<template>
  <focus-trap>
    <div
      tabindex="-1"
      class="modal d-block"
      @click.self="close"
      @keyup.esc="close"
    >
      <div class="modal-dialog modal-dialog-centered modal-557px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">
              Do not sell my personal information
            </h5>
            <button
              type="button"
              class="close"
              @click="close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              TinyURL does not sell any personal information you provide to us,
              however, some local jurisdictions may require us to allow you to
              opt-out anyways, so we've made this nifty little toggle switch for
              your enjoyment.
            </p>

            <div class="custom-control custom-switch">
              <input
                id="opt-out"
                v-model="strictPrivate"
                type="checkbox"
                class="custom-control-input"
              >
              <label
                v-if="strictPrivate"
                class="custom-control-label"
                for="opt-out"
              >Do not sell my personal information</label>
              <label
                v-else
                class="custom-control-label"
                for="opt-out"
              >Do not sell my personal information</label>
            </div>

            <p class="small text-muted">
              Using this toggle will result in us setting a cookie to remember
              your choice. Using a different web browser will require you to use
              this toggle again on that device so we can set this option. Please
              see our
              <router-link :to="{ name: 'privacy' }">
                privacy policy
              </router-link>
              for more information on how we use your personal information and
              how we use cookies to enhance our site.
            </p>
          </div>
        </div>
      </div>
    </div>
  </focus-trap>
</template>

<script>
export default {
  name: "PersonalInformationWarning",

  data: () => ({
    strictPrivate: false,
  }),

  watch: {
    strictPrivate() {
      this.$cookies.set(
        "tinyStrictPrivate",
        this.strictPrivate ? "true" : "false",
        Infinity,
      );
    },
  },

  created() {
    this.strictPrivate = this.$cookies.get("tinyStrictPrivate") === "true";
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
